import React, { useRef, useState, useCallback } from "react";
import { RCCDropDownItem, RCCIcon, RCCServicesApi, RCCTooltip } from "react-common-components";
import { IDashboard, IRefDashboardModals } from "src/components/DashboardComponents/ModalAddDashboard/interface";
import Loader from "src/components/Loader";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import ModalsDashboard from "src/components/DashboardComponents/ModalAddDashboard";
import { useHistory } from "react-router-dom";
import DropdownWithBackground from "src/components/DropdownWithBackground";
import getHomePageLink from "src/utils/getHomePageLink";
import { useAuth } from "src/context/Auth/context";

const DashboardsList: React.FC = () => {
	const { translate } = useTranslation();
	const { defaultDashboard } = useAuth();
	const history = useHistory();
	const [dashboards, setDashboards] = useState<IDashboard[] | undefined>(undefined);
	const modalsDashboardRef = useRef<IRefDashboardModals>(null);

	const opened = useRef<boolean>(false);

	const actionButtonShowDashboards = () => {
		if(!opened.current)		
			loadDashboards();
		opened.current = !opened.current;
	};

	const loadDashboards = useCallback(async () => {
		const {data} = await RCCServicesApi.getRequest({
			method: "Dashboard/List"
		});
		setDashboards(data);
	}, []);

	const onCallbackAdd = (data: IDashboard) => {
		setDashboards((prevState) => {
			if(prevState === undefined)
				return [data];

			return [data, ...prevState];
		});
	};

	return (
		<>
			<DropdownWithBackground
				position="bottomEnd"
				callerComponent={<RCCTooltip
					color="main"
					text="Dashboard"
					position="bottom"
					styleInline="line-height: 1rem;"
				>
					<button type="button" className="buttons-toggle" onClick={actionButtonShowDashboards}>
						<RCCIcon name="dashboard" size={28}/>
					</button>
				</RCCTooltip>}
				styleInline="display: flex; align-items: center; > ul {max-width: 300px; > li { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } } }"
			>					
				{!dashboards && (
					<Loader />
				)} 
				
				<RCCDropDownItem
					selfEnclose
					onClick={() => history.push(getHomePageLink("1", defaultDashboard))}
				>
					<RCCIcon name="dashboardOutline" />
					{translate("Página inicial")} - {translate("Dashboard")}
				</RCCDropDownItem>
					
				{defaultDashboard !== null && (
					<RCCDropDownItem
						selfEnclose
						onClick={() => history.push("/")}
					>
						{translate("Dashboard padrão")} Scoreplan
					</RCCDropDownItem>
				)}

				<hr />

				{dashboards && dashboards.length === 0 && (
					<Title color="purple" size="sm" marginBottom={-8} marginTop={-8}>
						{translate("Nenhuma dashboard encontrada")}
					</Title>
				)}

				{dashboards && dashboards.length > 0 && dashboards.map((dashboard) => (
					<RCCDropDownItem
						key={`dropdown-dashboard-item-${dashboard.daa001Id}`}
						selfEnclose
						onClick={() => history.push(`/dashboard/${dashboard.daa001Id}`)}
					>
						{dashboard.daa001Titulo}
					</RCCDropDownItem>
				))}
				
				<hr />
				<RCCDropDownItem
					selfEnclose
					onClick={() => modalsDashboardRef.current?.actionButtonAdd(onCallbackAdd)}
				>
					<RCCIcon name="plus" />
					{translate("Adicionar dashboard")}
				</RCCDropDownItem>
			</DropdownWithBackground>
			<ModalsDashboard ref={modalsDashboardRef}/>
		</>
	);
};

export default DashboardsList;
